const CARDS = [
  {
    id: 1,
    title: '《女神降临》—— 化妆逆袭甜漫',
    desc: '自卑女孩通过化妆变身校园女神，高甜恋爱与爆笑日常交织，下拉式漫画阅读体验让甜蜜加倍。',
    category: '恋爱甜漫',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20scene%20with%20a%20girl%20transforming%20through%20makeup%2C%20soft%20pink%20and%20warm%20lighting%2C%20Korean%20webtoon%20style%2C%20delicate%20art%2C%20romantic%20atmosphere%2C%20clean%20cream%20background%2C%20professional%20illustration&width=600&height=400&seq=cards-01&orientation=landscape',
    stats: { views: '128万', chaps: '连载至156话' },
  },
  {
    id: 2,
    title: '《进击的巨人》—— 史诗级巨作',
    desc: '人类与巨人之间的生存之战，深刻的世界观与震撼的剧情，下拉式浏览让宏大场面更具冲击力。',
    category: '奇幻史诗',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20sky%2C%20Japanese%20manga%20art%20style%2C%20warm%20orange%20and%20dark%20contrast%2C%20cinematic%20composition%2C%20professional%20illustration%2C%20clean%20background&width=600&height=400&seq=cards-02&orientation=landscape',
    stats: { views: '356万', chaps: '已完结139话' },
  },
  {
    id: 3,
    title: '《全知读者视角》—— 生存悬疑',
    desc: '小说变成现实，唯一读过结局的主角如何在末世中求生。下拉式阅读完美呈现紧张刺激的节奏感。',
    category: '悬疑烧脑',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20scene%20with%20a%20protagonist%20reading%20in%20an%20apocalyptic%20setting%2C%20Korean%20manhwa%20style%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20shadow%20contrast%2C%20tense%20atmosphere%2C%20professional%20digital%20art%2C%20clean%20composition&width=600&height=400&seq=cards-03&orientation=landscape',
    stats: { views: '215万', chaps: '连载至213话' },
  },
  {
    id: 4,
    title: '《鬼灭之刃》—— 和风战斗经典',
    desc: '少年炭治郎为救妹妹踏上斩鬼之路，日漫下拉式阅读呈现华丽的呼吸法战斗特效。',
    category: '热血战斗',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20style%20action%20scene%20with%20sword%20fighting%20and%20water%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20warm%20orange%20and%20blue%20contrast%2C%20dynamic%20composition%2C%20professional%20manga%20art%2C%20clean%20background&width=600&height=400&seq=cards-04&orientation=landscape',
    stats: { views: '489万', chaps: '已完结205话' },
  },
  {
    id: 5,
    title: '《某天成为公主》—— 宫廷浪漫',
    desc: '穿越成为小说中的悲情公主，用智慧和善良改写命运。精美的画风搭配下拉式流畅阅读。',
    category: '穿越宫廷',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20princess%20in%20a%20royal%20palace%20garden%2C%20Korean%20manhwa%20art%20style%2C%20elegant%20dress%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20delicate%20details%2C%20professional%20illustration%2C%20clean%20cream%20background&width=600&height=400&seq=cards-05&orientation=landscape',
    stats: { views: '167万', chaps: '连载至125话' },
  },
  {
    id: 6,
    title: '《排球少年！！》—— 青春热血',
    desc: '小个子少年追逐排球梦想，日漫下拉式完美展现比赛的速度感与团队羁绊，燃到停不下来。',
    category: '运动竞技',
    img: 'https://readdy.ai/api/search-image?query=Exciting%20volleyball%20match%20scene%20in%20anime%20style%2C%20dynamic%20action%20pose%2C%20warm%20gym%20lighting%2C%20Japanese%20sports%20manga%20art%2C%20energy%20and%20passion%2C%20professional%20illustration%2C%20clean%20composition&width=600&height=400&seq=cards-06&orientation=landscape',
    stats: { views: '298万', chaps: '已完结402话' },
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            热门连载
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">大家都在看的下拉式漫画</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">精选高人气连载作品，下拉式阅读给你最佳追漫体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((card) => (
            <article
              key={card.id}
              className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-50/80 transition-colors"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/60 text-background-50 text-xs font-medium backdrop-blur-sm">
                  {card.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.stats.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-file-list-3-line"></i>
                    {card.stats.chaps}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}